module.exports = __webpack_public_path__ + "img/prop5.21e1352d.svg";